<template>
  <div class="traffic-plan-list-main">
    <!-- 列表 -->
    <div class="traffic-plan-list-item-left">
      <!-- ------------------------------ 编辑/选择交通方案 ------------------------------>
      <el-card style="margin-bottom:5px"
               :body-style="{ padding: '10px'}"
               shadow="nerver">
        <traffic-editor ref="traffic_editor"
                        :TraverNameBetween="ItemNameBetween"
                        :TraverBetween="poi_between"
                        :TrafficId="TrafficId"
                        :routeMode="routeMode"
                        :TaxiIntroduce="TaxiIntroduce"
                        :TaxiFare="TaxiFare"
                        :planOfMap="planOfMap"
                        :TrafficIntroduce="TrafficIntroduce"
                        :TrafficPlan="TrafficPlan"
                        @selectTrafficPlan="selectTrafficPlan"></traffic-editor>
      </el-card>
    </div>
    <!-- 地图 -->
    <div class="traffic-plan-list-item-right">
      <!-------------------------------- 亮点路线地图 -------------------------------->
      <el-card shadow="never"
               :body-style="{ padding: '10px'}">
        <!-- 标签页 -->
        <el-tabs class="tab-way-map"
                 v-model="routeMode"
                 @tab-click="clickRouteMode"
                 type="border-card">
          <el-tab-pane name="walking"
                       label="徒步"></el-tab-pane>
          <el-tab-pane name="driving"
                       label="驾车"></el-tab-pane>
          <el-tab-pane name="bicycling"
                       label="骑行"></el-tab-pane>
          <el-tab-pane name="transit"
                       label="公交"></el-tab-pane>
        </el-tabs>

        <!-- 地图 -->
        <div style="border:1px solid lightgrey">
          <show-route-on-travel-plan ref="show_route_maps"
                                     :routeMode="routeMode"
                                     :fromLat="fromLat"
                                     :fromLng="fromLng"
                                     :toLat="toLat"
                                     :toLng="toLng"></show-route-on-travel-plan>
        </div>

      </el-card>

      <!-- 公交方案选择 的组件：-->
      <div>
        <transit-plan-show v-if="showTransit"
                           @selectTransitPlan="selectTransitPlan"
                           @bandTransitPlan="bandTransitPlan"
                           :planData="planData"></transit-plan-show>
      </div>
      <!-- 驾车方案选择 的组件：-->
      <div>
        <driving-plan-show v-if="showDriving"
                           @selectDrivingPlan="selectDrivingPlan"
                           @bandTransitPlan="bandTransitPlan"
                           :planData="planData"></driving-plan-show>
      </div>

    </div>

  </div>
</template>

<script>
import RouteShow from '../../components/map/RouteShow'
import TrafficEditor from '../../components/traver/TrafficEditor'
//
import TransitPlanShow from '../../components/traver/TransitPlanShow'
import DrivingPlanShow from '../../components/traver/DrivingPlanShow'
export default {
  name: 'travel-plan-traffic-editor',
  components: {
    'show-route-on-travel-plan': RouteShow,
    'traffic-editor': TrafficEditor,
    TransitPlanShow,
    DrivingPlanShow,
  },
  data() {
    return {
      fromLat: 39.984039,
      fromLng: 116.30763,
      toLat: 39.977263,
      toLng: 116.337063,
      routeMode: 'walking',
      showWalking: false,
      showTransit: false,
      showDriving: false,
      trafficPlanData: [],
      ItemNameBetween: this.TraverOrResidenceBetween,
      poi_between: [],
      TrafficId: null,
      TaxiIntroduce: '',
      TaxiFare: '',
      planOfMap: null,
      TrafficIntroduce: '',
      planData: [], // 显示交通方案的数据，

      TrafficPlan: [],
      policy: '',
    }
  },
  props: {
    TraverOrResidenceBetween: Array,
  },
  watch: {
    TraverOrResidenceBetween(newVal) {
      this.ItemNameBetween = newVal
    },
    TaxiIntroduce(newVal) {
      this.TaxiIntroduce = newVal
    },
    TaxiFare(newVal) {
      this.TaxiFare = newVal
    },
  },
  methods: {
    // 根据父组件的 poi——id 绘制路线和 点标记
    makePointAndRoute(poi_id, next_poi_id) {
      this.routeMode = 'walking'
      this.poi_between = []
      this.poi_between.push(poi_id)
      this.poi_between.push(next_poi_id)
      // 1. 匹配交通方案 poi_id
      this.$http
        .get(
          `/traver/match_traffic_two_poi?poi_list=${[
            poi_id,
            next_poi_id,
          ]}&traffic_class=1`
        )
        .then((res) => {
          // console.log('请求两点直接的数据')
          // console.log(res)
          if (res.data.errno == '0') {
            // 获得交通id
            // console.log(res)
            this.TrafficId = res.data.data.traffic_id
            this.TaxiIntroduce = res.data.data.take_taxi
            // 交通方案
            this.TrafficPlan = res.data.plan
            // console.log(this.TrafficPlan)
            // console.log(this.dayTrip)
            this.TaxiFare = '打车费用请选择驾车查看'
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
      new Promise((resolve, reject) => {
        // 2.
        // 获取出发点坐标、抵达 ：
        this.$http
          .get(`/traver/get_lat_lng?poi_id=${poi_id}&next_poi=${next_poi_id}`)
          .then((res) => {
            if (res.data.errno == '0') {
              // console.log(res.data)
              this.fromLat = parseFloat(res.data.data.lat)
              this.fromLng = parseFloat(res.data.data.lng)
              this.toLat = parseFloat(res.data.next_data.lat)
              this.toLng = parseFloat(res.data.next_data.lng)
              resolve()
            }
          })
      }).then((res) => {
        // -----------------服务端获取 ->更新 路线规划数据-----------------
        // 根据 路线模式获取路线数据
        if (this.routeMode == 'transit') {
          this.planData = []
          this.planData = res.data.data
        } else if (this.routeMode == 'bicycling') {
          this.planData = []
          this.planData = res.data.data
        } else if (this.routeMode == 'walking') {
          this.planData = []
          this.$http
            .get(
              `/traver/api_map_qq_routes_walking?from_lat=${this.fromLat}&from_lng=${this.fromLng}&to_lat=${this.toLat}&to_lng=${this.toLng}&route_mode=${this.routeMode}`
            )
            .then((res) => {
              console.log('交通数据：', res)
              if (res.data.errno == '0') {
                this.planOfMap = res.data.data[0]
                // 获取交通说明
                if (res.data.data[0].distance > 1000) {
                  this.TrafficIntroduce =
                    '距离：' +
                    res.data.data[0].distance / 1000 +
                    '公里，耗时约：' +
                    res.data.data[0].duration +
                    '分钟'
                } else if (res.data.data[0].distance < 1000) {
                  this.TrafficIntroduce =
                    '距离：' +
                    res.data.data[0].distance +
                    '米，耗时约：' +
                    res.data.data[0].duration +
                    '分钟'
                }

                // 解压poyline
                let pl = this.underPolyline(res.data.data[0].polyline)
                // 更新路线
                this.$refs.show_route_maps.updateRoutes([
                  {
                    id: this.traffic_id,
                    styleId: 'style_walking',
                    paths: pl,
                  },
                ])
                // --------------------------添加地图处理点标记--------------------------
                // 更新地图点标记
                let from_to_list = [
                  {
                    id: 1, // 开始的 marker_id
                    lat: this.fromLat,
                    lng: this.fromLng,
                  },
                  {
                    id: 2, // 结束的 marker_id
                    lat: this.toLat,
                    lng: this.toLng,
                  },
                ]
                // 添加标记点
                this.$refs.show_route_maps.addMarkerPointerCenter(from_to_list)
                //
              }
            })
        } else if (this.routeMode == 'driving') {
          // 驾车方案：
          this.planData = []
          console.log('driving')
          this.getDrivingRoutesFromAPI(
            this.fromLat,
            this.fromLng,
            this.toLat,
            this.toLng,
            this.routeMode
          )
        }
        // -----------------【结束】服务端获取 ->更新 路线规划数据-----------------
      })
    },
    // 切换交通模式:步行，自驾，等
    clickRouteMode() {
      // this.routeMode = val.name
      this.$nextTick(() => {
        // 判断是否有 标点 和规划路线
        // if (this.TrafficId == null) {
        // } else {
        //   console.log('移除已有折线:', this.TrafficId)
        //   this.$refs.show_route_maps.removeRoutes(this.TrafficId)
        // }
        // 打印交通方式
        // console.log(this.routeMode)

        if (this.routeMode == 'transit') {
          this.showTransit = true
          this.showDriving = false
          this.planData = []
          this.getTransitRoutesFromAPI(
            1622948400, //11:00
            this.fromLat,
            this.fromLng,
            this.toLat,
            this.toLng,
            this.routeMode,
            this.policy
          )
        } else if (this.routeMode == 'bicycling') {
          this.showTransit = false
          this.showDriving = false
          this.planData = []
          // console.log('bicycling')
          this.getBicyclingRoutesFromAPI(
            this.fromLat,
            this.fromLng,
            this.toLat,
            this.toLng,
            this.routeMode
          )
        } else if (this.routeMode == 'walking') {
          this.showTransit = false
          this.showDriving = false
          this.planData = []
          // console.log('walking')
          this.getWalkingRoutesFromAPI(
            this.fromLat,
            this.fromLng,
            this.toLat,
            this.toLng,
            this.routeMode
          )
        } else if (this.routeMode == 'driving') {
          this.showTransit = false
          this.showDriving = true
          // 驾车
          this.planData = []
          console.log('driving')
          this.getDrivingRoutesFromAPI(
            this.fromLat,
            this.fromLng,
            this.toLat,
            this.toLng,
            this.routeMode,
            this.policy
          )
        }
      })
    },
    // 获取【步行】路线 getRoutesFromAPI(this.fromLat,this.fromLng,this.toLat,this.toLng,this.routeMode,policy)
    getWalkingRoutesFromAPI(fromLat, fromLng, toLat, toLng, routeMode) {
      this.$http
        .get(
          `/traver/api_map_qq_routes_walking?from_lat=${fromLat}&from_lng=${fromLng}&to_lat=${toLat}&to_lng=${toLng}&route_mode=${routeMode}`
        )
        .then((res) => {
          if (res.data.errno == '0') {
            // 获取交通说明
            if (res.data.data[0].distance > 1000) {
              this.TrafficIntroduce =
                '距离：' +
                res.data.data[0].distance / 1000 +
                '公里，耗时约：' +
                res.data.data[0].duration +
                '分钟'
            } else if (res.data.data[0].distance < 1000) {
              this.TrafficIntroduce =
                '距离：' +
                res.data.data[0].distance +
                '米，耗时约：' +
                res.data.data[0].duration +
                '分钟'
            }
            // 解压poyline
            let pl = this.underPolyline(res.data.data[0].polyline)

            // 更新路线
            this.$refs.show_route_maps.updateRoutes([
              {
                id: this.traffic_id,
                styleId: 'style_walking',
                paths: pl,
              },
            ])
            // this.$refs.show_route_maps.updateBack(
            //   res.data.data[0],
            //   this.TrafficId,
            //   this.routeMode
            // )
          }
        })
    },
    // 获取【骑行】路线 getRoutesFromAPI(this.fromLat,this.fromLng,this.toLat,this.toLng,this.routeMode,policy)
    getBicyclingRoutesFromAPI(fromLat, fromLng, toLat, toLng, routeMode) {
      this.$http
        .get(
          `/traver/api_map_qq_routes_bicycling?from_lat=${fromLat}&from_lng=${fromLng}&to_lat=${toLat}&to_lng=${toLng}&route_mode=${routeMode}`
        )
        .then((res) => {
          if (res.data.errno == '0') {
            // 获取交通说明
            this.TrafficIntroduce =
              '距离：' +
              res.data.data[0].distance / 1000 +
              '公里，耗时约：' +
              res.data.data[0].duration +
              '分钟'
            // 打车费用
            this.TaxiFare = '打车费用请选择驾车查看'
            // 解压poyline
            let pl = this.underPolyline(res.data.data[0].polyline)

            // 更新路线
            this.$refs.show_route_maps.updateRoutes([
              {
                id: this.traffic_id,
                styleId: 'style_bicycling',
                paths: pl,
              },
            ])
          }
        })
    },
    // 获取【驾车】路线 getRoutesFromAPI(this.fromLat,this.fromLng,this.toLat,this.toLng,this.routeMode,policy)
    getDrivingRoutesFromAPI(fromLat, fromLng, toLat, toLng, routeMode, policy) {
      this.$http
        .get(
          `/traver/api_map_qq_routes_driving?from_lat=${fromLat}&from_lng=${fromLng}&to_lat=${toLat}&to_lng=${toLng}&route_mode=${routeMode}&policy=${policy}`
        )
        .then((res) => {
          console.log(res)
          if (res.data.errno == '0') {
            // 解压
            res.data.data.forEach((route) => {
              this.deCompressionPolyline(route.polyline)
            })
            // 方案选项
            this.planData = res.data.data
            // 获取交通说明
            if (res.data.data[0].distance > 1000) {
              this.TrafficIntroduce =
                '距离：' +
                res.data.data[0].distance / 1000 +
                '公里，耗时约：' +
                res.data.data[0].duration +
                '分钟'
            } else if (res.data.data[0].distance < 1000) {
              this.TrafficIntroduce =
                '距离：' +
                res.data.data[0].distance +
                '米，耗时约：' +
                res.data.data[0].duration +
                '分钟'
            }
            // 打车费用约：[服务端返回，所以不用保存]
            this.TaxiFare =
              '打车费用约：' + res.data.data[0].taxi_fare.fare + '元'
            // 解压poyline
            let pl = this.getPolyLineLatLng(res.data.data[0].polyline)

            // 更新路线
            this.$refs.show_route_maps.updateRoutes([
              {
                id: this.traffic_id,
                styleId: 'style_driving',
                paths: pl,
              },
            ])
          }
        })
    },
    // 获取【公共交通】路线 getRoutesFromAPI(this.fromLat,this.fromLng,this.toLat,this.toLng,this.routeMode,policy)
    getTransitRoutesFromAPI(
      selectTime,
      fromLat,
      fromLng,
      toLat,
      toLng,
      routeMode,
      policy
    ) {
      this.$http
        .get(
          `/traver/api_map_qq_routes_transit?departure_time=${selectTime}&from_lat=${fromLat}&from_lng=${fromLng}&to_lat=${toLat}&to_lng=${toLng}&route_mode=${routeMode}&policy=${policy}`
        )
        .then((res) => {
          console.log(res)
          if (res.data.errno == '0') {
            // console.log('服务端获取的数据')
            // 1.显示方案选项
            this.planData = res.data.data
            // 2.获取交通说明
            // this.TrafficIntroduce =
            // 3.更新路线 循环
            let pl_list = []
            //   {
            //   id: TrafficId,
            //   styleId: 'style_blue',
            //   paths: pl,
            // }
            // 打车费用
            this.TaxiFare = '打车费用请选择驾车查看'
            // 全部数据都解压一遍
            res.data.data.forEach((route) => {
              //console.log(route) //坐标解压（返回的点串坐标，通过前向差分进行压缩）
              route.steps.forEach((route_step) => {
                if (route_step.mode == 'WALKING') {
                  // 解压 步行
                  let coors = route_step.polyline
                  //坐标解压（返回的点串坐标，通过前向差分进行压缩）
                  let kr = 1000000
                  for (let i = 2; i < coors.length; i++) {
                    coors[i] = Number(coors[i - 2]) + Number(coors[i]) / kr
                  }
                } else if (route_step.mode == 'TRANSIT') {
                  route_step.lines.forEach((line) => {
                    let coors = line.polyline
                    //坐标解压（返回的点串坐标，通过前向差分进行压缩）
                    let kr = 1000000
                    for (let i = 2; i < coors.length; i++) {
                      coors[i] = Number(coors[i - 2]) + Number(coors[i]) / kr
                    }
                  })
                }
              })
            })
            // 解压完毕,开始绘制
            res.data.data[0].steps.forEach((step_item) => {
              // 根据腾讯提供的数据接口[步行 , 公交 , 步行 , 公交 , 步行(到终点)]
              if (step_item.mode == 'WALKING') {
                // console.log('步行')--------------------------
                let pl = this.getPolyLineLatLng(step_item.polyline)

                // 构建 pl_list_item
                let pl_wlaking_item = {
                  id: this.traffic_id,
                  styleId: 'style_walking',
                  paths: pl,
                }
                pl_list.push(pl_wlaking_item)
              } else if (step_item.mode == 'TRANSIT') {
                // console.log("公共交通")--------------------------
                step_item.lines.forEach((line_item) => {
                  if (line_item.vehicle == 'BUS') {
                    // console.log('搭乘公共汽车')
                    // 搭乘公共汽车
                    let pl = this.getPolyLineLatLng(line_item.polyline)
                    let pl_wlaking_item = {
                      id: this.traffic_id + line_item.id,
                      styleId: 'style_bus',
                      paths: pl,
                    }
                    pl_list.push(pl_wlaking_item)
                  } else if (line_item.vehicle == 'SUBWAY') {
                    // console.log('搭乘地铁')
                    // 搭乘地铁
                    let pl = this.getPolyLineLatLng(line_item.polyline)
                    let pl_wlaking_item = {
                      id: this.traffic_id + line_item.id,
                      styleId: 'style_subway',
                      paths: pl,
                    }
                    pl_list.push(pl_wlaking_item)
                  } else if (line_item.vehicle == 'RAIL') {
                    // console.log('搭乘火车')
                    // 搭乘火车
                    let pl = this.getPolyLineLatLng(line_item.polyline)
                    let pl_wlaking_item = {
                      id: this.traffic_id + line_item.id,
                      styleId: 'style_rail',
                      paths: pl,
                    }
                    pl_list.push(pl_wlaking_item)
                  }
                })
              }
            })
            // 通过refs，批量添加折线
            // console.log(pl_list)
            //新的折线添加到图层中
            this.$refs.show_route_maps.updateRoutes(pl_list)

            //
          }
        })
    },
    // --------------------------------------------
    // 用于编辑的交通方案
    selectTransitPlan(pl_list) {
      this.$refs.show_route_maps.updateRoutes(pl_list)
    },
    selectDrivingPlan(pl_list) {
      this.$refs.show_route_maps.updateRoutes(pl_list)
    },
    selectTrafficPlan(traffic_plan_list) {
      // console.log('选择方案:', traffic_plan_list)
      this.$emit('addTrafficPlanToTraverPoint', traffic_plan_list)
    },

    // 选择 服务端计算后的路线方案
    bandTransitPlan(item, introduce) {
      // console.log(item)
      this.TrafficIntroduce = introduce
      this.planOfMap = item
    },
    // 解压 polyline + 生成坐标
    underPolyline(polyline) {
      let coors = polyline
      let pl = []
      //坐标解压（返回的点串坐标，通过前向差分进行压缩），提前解压
      let kr = 1000000
      for (let i = 2; i < coors.length; i++) {
        coors[i] = Number(coors[i - 2]) + Number(coors[i]) / kr
      }
      //将解压后的坐标生成LatLng数组
      for (var i = 0; i < coors.length; i += 2) {
        pl.push(new TMap.LatLng(coors[i], coors[i + 1]))
      }
      return pl
    },
    // 解压 polyline  deCompressionPolyline()
    deCompressionPolyline(polyline) {
      let coors = polyline
      let pl = []
      //坐标解压（返回的点串坐标，通过前向差分进行压缩），提前解压
      let kr = 1000000
      for (let i = 2; i < coors.length; i++) {
        coors[i] = Number(coors[i - 2]) + Number(coors[i]) / kr
      }
      return pl
    },
    // 生成坐标
    getPolyLineLatLng(coors) {
      let pl = []
      //将解压后的坐标生成LatLng数组
      for (var i = 0; i < coors.length; i += 2) {
        pl.push(new TMap.LatLng(coors[i], coors[i + 1]))
      }
      return pl
    },
  },
}
</script>

<style>
.traffic-plan-list-main {
  display: flex;
  justify-content: space-between;
}
.traffic-plan-list-item-left {
  /* border: 1px solid red; */
  width: 50%;
  margin-right: 10px;
}
.traffic-plan-list-item-right {
  /* border: 1px solid green; */
  width: 50%;
}
</style>